/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bot_Ua_Browser_CaptionInputs */

const en_bot_ua_browser_caption = /** @type {(inputs: Bot_Ua_Browser_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Isolated browser (screenshots, JavaScript pages)`)
};

const id_bot_ua_browser_caption = /** @type {(inputs: Bot_Ua_Browser_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Browser terisolasi (tangkapan layar, halaman JavaScript)`)
};

/**
* | output |
* | --- |
* | "Isolated browser (screenshots, JavaScript pages)" |
*
* @param {Bot_Ua_Browser_CaptionInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const bot_ua_browser_caption = /** @type {((inputs?: Bot_Ua_Browser_CaptionInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bot_Ua_Browser_CaptionInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_bot_ua_browser_caption(inputs)
	return en_bot_ua_browser_caption(inputs)
});